import React from 'react';
import * as stylex from "@stylexjs/stylex";
import Table from "nood-comp/src/comp/data/table/Table";
import { queryStringModifier } from "nood-comp/src/util/converters/converters";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
export default function Campuses(props) {
  return /*#__PURE__*/React.createElement(Table, {
    key: "table-campuses",
    data_source: "/campuses",
    rowPadding: 5,
    paging: {
      sorters: [{
        property: 'created_dt',
        isAsc: false
      }]
    },
    cols: [{
      property: "short_name",
      width: 150,
      filterTextfieldWidth: 120,
      label: "Short Name",
      filterType: "text",
      icon: "tag",
      to: function to(obj, idx) {
        return queryStringModifier({
          queryString: document.location.search,
          modifiers: {
            "do": "view",
            id: obj.id
          }
        });
      }
    }, {
      property: "name",
      label: "Name",
      filterType: "text",
      icon: "menu"
    }, {
      property: "system.short_name",
      label: "System",
      width: 150
    }, {
      label: "",
      width: 50,
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement(ElapsedTime, {
          datetime: obj.created_dt
        });
      }
    }]
  });
}

// @ts-ignore